import api from './api';

const partnerService = {
  getApplications: async (params = {}) => {
    const response = await api.get('/partners', { params });
    return response.data;
  },

  getApplication: async (id) => {
    const response = await api.get(`/partners/${id}`);
    return response.data;
  },

  getStats: async () => {
    const response = await api.get('/partners/stats');
    return response.data;
  },

  apply: async (data) => {
    const response = await api.post('/partners/apply', data);
    return response.data;
  },

  getMyApplication: async () => {
    const response = await api.get('/partners/my-application');
    return response.data;
  },

  approve: async (id) => {
    const response = await api.put(`/partners/${id}/approve`);
    return response.data;
  },

  reject: async (id, reason) => {
    const response = await api.put(`/partners/${id}/reject`, { review_note: reason });
    return response.data;
  },

  // KBIS
  getKbisStatus: async () => {
    const response = await api.get('/partners/kbis/status');
    return response.data;
  },

  uploadKbis: async (fileBase64) => {
    const response = await api.post('/partners/kbis/upload', { file: fileBase64 });
    return response.data;
  },

  uploadDocument: async (fileBase64, docType) => {
    const response = await api.post('/partners/upload', { file: fileBase64, doc_type: docType });
    return response.data;
  },

  getKbisPendingList: async () => {
    const response = await api.get('/partners/kbis/pending');
    return response.data;
  },

  approveKbis: async (userId) => {
    const response = await api.put(`/partners/${userId}/kbis/approve`);
    return response.data;
  },

  rejectKbis: async (userId) => {
    const response = await api.put(`/partners/${userId}/kbis/reject`);
    return response.data;
  },
};

export default partnerService;
